<template>
<div>
  <el-form-item label="驳回原因">
    <el-input v-model="reason"
              placeholder="驳回时请填写，通过无需填写"></el-input>
  </el-form-item>
  <div class="buttons">
    <el-button type="success" @click="approvePass">BO审批 通过</el-button>
    <el-button type="danger" @click="approveFail">BO审批 驳回</el-button>
  </div>
</div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: '',
    }
  },
  data () {
    return {
      reason: '',
    }
  },
  methods: {
    // 通过
    approvePass (done) {
      this.$confirm('即将通过本开票申请，是否确认？', '通过开票申请确认').then(() => {
        request.common('buApprovePassReceiptApply', {id: this.id}).then((res) => {
          this.$router.push('/invoice-apply/table')
        })
      })
    },
    // 驳回
    approveFail () {
      if (this.reason) {
        let reason = this.reason
        this.$confirm('即将驳回本开票申请，是否确认？', '驳回开票申请确认', { type: 'warning',
          center: true}).then(() => {
          request.common('buApproveRejectReceiptApply', {id: this.id, status: 3, reason: reason}).then((res) => {
            this.$router.push('/invoice-apply/table')
          })
        })
      } else {
        this.$alert('必须填写驳回原因', '提示', {
          type: 'error',
        })
      }
    },
  }
}
</script>

<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
.buttons {
  float: right;
  padding: 0 30px 30px 0;
}
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/invoice-apply/components/InvoiceApplyApprove/InvoiceApplyBuApprove.vue